jQuery(function( $ ) {
	
    var slider_width = $('.searchSlider').width();//get width automatically
	$('#searchSlider-button').click(function() {
    
    if($(this).css("margin-right") == slider_width+"px" && !$(this).is(':animated')) {
        $('.searchSlider').animate({"width": '200px'});
        $('.searchSlider').addClass("full");
    }
    else
    {
        if(!$(this).is(':animated'))//prevent double click to double margin
        {
            $('.searchSlider').animate({"width": '0'});
        }
    }

  });
  
 });